module.exports = __webpack_public_path__ + "AdithyaPatel-b74d2787.webp";